<template>
  <div class="px-4 d-flex">
    <div class="hidden-md-and-down mr-2" style="width: 250px; flex: 0 0 250px">
      <div style="position: fixed; top: calc(var(--v-layout-top) + 30px); bottom: 0; width: 250px">
        <v-fade-transition>
          <div v-if="user.id" class="px-2 d-flex flex-column h-100">
            <div class="text-h6 d-flex">
              <user-avatar :user="user" :title="$t('ACCOUNT.CHANGE_AVATAR')" class="mr-4" :size="32"></user-avatar>
              {{ $t('HOME.WELCOME') }}, {{ user.firstname }} !
            </div>
            <div class="text-medium-emphasis mt-2">
              {{ $t('HOME.WELCOME_MESSAGE') }}
            </div>
            <div class="mt-auto"></div>
            <div class="hidden-small-height position-relative" style="flex: 1 1 100%; max-height: 400px">
              <div class="text-center" style="position: absolute; inset: 24px 0">
                <img v-reload-src-on-mount src="@/img/animations/illustration-home.svg" style="max-height: 100%; max-width: 100%">
              </div>
            </div>
            <div v-if="user.company && user.company.logo" class="mb-3 text-center" style="height: 50px; line-height: 50px">
              <img :src="user.company.logo" style="height: 100%; max-width: 200px">
            </div>
          </div>
        </v-fade-transition>
      </div>
    </div>
    <div class="home-user pb-6 pl-2 flex-grow-1 overflow-hidden">
      <div v-if="errors">{{ errors }}</div>
      <v-fade-transition v-else>
        <v-row v-if="userLoaded" class="mt-0">
          <v-col v-if="HomeUserStore.loaded && ! hasData" cols="12">
            <v-card class="pa-6">
              <v-card-title class="d-flex justify-center">
                <h3>{{ $t('HOME.FIRST_STEPS') }}</h3>
              </v-card-title>
              <v-card-text>
                <p class="mx-auto text-center" style="max-width: 400px">{{ $t('HOME.FIRST_STEPS_MESSAGE') }}</p>
                <div class="mt-4 d-flex justify-center gap-4 flex-wrap">
                  <v-btn color="primary" rounded size="large" @click="openOnBoardingWelcomeModal">{{ $t('HOME.OPEN_ONBOARDING') }}</v-btn>
                  <v-btn to="projects" color="primary" rounded size="large" variant="outlined">{{ $t('ONBOARDING.ACCESS_PROJECTS') }}</v-btn>
                </div>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col sm="6" cols="12">
            <home-user-projects></home-user-projects>
          </v-col>
          <v-col v-if="HomeUserStore.keyDates" sm="6" cols="12">
            <home-user-keydates></home-user-keydates>
          </v-col>
          <v-col sm="6" cols="12">
            <home-user-actions></home-user-actions>
          </v-col>
          <v-col cols="12">
            <home-user-planning></home-user-planning>
          </v-col>
        </v-row>
      </v-fade-transition>
    </div>
  </div>
</template>

<style>
  .home-user ul {
    margin-bottom: 0;
    padding: 0 0 16px !important;
    list-style: none;
  }
  .home-user li {
    padding: 2px 0;
  }

  .home-user .link {
    padding: 0 2px;
    border: 1px solid transparent;
    border-radius: 4px;
    transition: all .3s;
  }

  .home-user .link:hover {
    text-decoration: none;
    background-color: #e6e6e6;
    border-color: #ddd;
  }

  @media (max-height: 600px) {
    .hidden-small-height {
      display: none;
    }
  }
</style>

<script>
  import { mapStores } from 'pinia';
  import useUiModalsStore from '@/stores/ui/modals';
  import useHomeUserStore from '@/stores/home-user';
  import useUsersStore from '@/stores/users';
  import useUsersAccessRightStore from '@/stores/users/accessRight';
  import HomeUserProjects from './HomeUserProjects.vue';
  import HomeUserActions from './HomeUserActions.vue';
  import HomeUserPlanning from './HomeUserPlanning.vue';
  import HomeUserKeydates from './HomeUserKeydates.vue';

  export default {
    components: {
      HomeUserProjects,
      HomeUserActions,
      HomeUserPlanning,
      HomeUserKeydates,
    },
    data() {
      return {
        errors: "",
        uiModalsStore: useUiModalsStore(),
        usersStore: useUsersStore(),
        usersAccessRightStore: useUsersAccessRightStore(),
      };
    },
    computed: {
      user() {
        return this.usersStore.user;
      },
      accessRight() {
        return this.usersAccessRightStore;
      },
      hasData() {
        return this.HomeUserStore.plannings.length;
      },
      userLoaded() {
        return this.user.id;
      },
      ...mapStores(useHomeUserStore),
    },
    created() {
      this.HomeUserStore.$reset();
      this.HomeUserStore.load().catch((message) => {
        this.errors = message;
      });
    },
    methods: {
      openOnBoardingWelcomeModal() {
        this.uiModalsStore.setOnBoardingWelcomeModal(true);
      },
    },
  };
</script>
